import React, { useContext, useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import AppContext from '../../AppContext';
import QuickSightTabs from '../QuickSightTabs/QuickSightTabs';
import Attribution from './Attribution';


const QuickSightDashboard2 = ({ dashboardId, dashboardTitle, dashboardType, dashboardSubtype, apiKey, realTime, embedContext, classes, height=1200, dropdowns,initialParams, singleSheet = false }) => {
    
  const { dashboard, setDashboard } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [sheets, setSheets] = useState([]);
  const [activeSheet, setActiveSheet] = useState();
  const [numberOfParameterChanges, setNumberOfParameterChanges] = useState(1);

  useEffect(() => {
    if(!!dashboardTitle) {
      document.title = dashboardTitle
    } 
  }, [dashboardTitle])

//   useEffect(() => {
//     let timer;
//     if(realTime && dashboard) {
//       timer = setTimeout(() => {
//         dashboard.setParameters([{'Name': "refreshParameter", 'Values': Date.now()}]);
//         // console.log('asdlfkjslkfdjs')
//       }, 5000);

//     }
//     return () => { clearTimeout(timer) };
//   },[realTime, dashboard])


  const getDashboardUrl = async (params = []) => {
    try {

      let url;
      let headers;
      // let singleSheet = false;
      // if(apiKey && dashboardType?.toLowerCase() === 'topic') {
      //   url = 'get-anonymous-quicksight-q-url?topic_id';
      //   headers = { 'X-API-Key': apiKey }
      // } else if (apiKey) {
        url = 'get-anonymous-quicksight-url?dashboard_id';
        headers = { 'X-API-Key': apiKey };
        // singleSheet = true;
      // } else if(dashboardType?.toLowerCase() === 'topic') {
      //   url='get-quicksight-q-url?topic_id'
      //   headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
      // } else {
      //   url='get-quicksight-url?dashboard_id'
      //   headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
      // }
      try {
        const response = await API.get('APIEndpoint', `/${url}=${dashboardId}&hostname=${window.location.origin}`, {response: true, headers: headers}) 

        if(response?.data?.url) {
          const { embedDashboard, embedGenerativeQnA } = embedContext;
          const frameOptions = {
              url: response.data.url,
              container: document.getElementById(dashboardId),
              height: "100%",
              width: "100%",
              // onChange: ((e,d) => {console.log('frameoptions onChange',e,d)}),
              // onMessage: ((e,d) => {console.log('frameoptions onMessage',e,d)}),

          };
          const contentOptions = {
              parameters: params.push({'Name': "URL", 'Values': [window.location.host]}),
              toolbarOptions: {
                  export: false,
                  undoRedo: false,
                  reset: false,
                  bookmarks:false
              },
              sheetOptions: {
              //     initialSheetId: '<YOUR_SHEETID>',
                  singleSheet:  true,                        
              //     emitSizeChangedEventOnSheetChange: false,
              },
              attributionOptions: {
                  overlayContent: false,
              },
              onMessage: async (messageEvent, experienceMetadata) => {
                  // console.log('messageEvent, experienceMetadata', messageEvent, experienceMetadata)
                  switch (messageEvent.eventName) {
                                case 'EXPERIENCE_INITIALIZED': { 
                                    // console.log("All visuals are loaded. The title of the document:", messageEvent.message.title);
                                    setLoading(false)
                                    break;
                                }
                                // case 'ERROR_OCCURRED': {
                                //     console.log("Error occurred while rendering the experience. Error code:", messageEvent.message.errorCode);
                                //     break;
                                // }
                                case 'PARAMETERS_CHANGED': {
                                    // console.log("Parameters changed. Changed parameters:", messageEvent);
                                    setNumberOfParameterChanges(x => x + 1);
                                    // if(messageEvent?.message?.changedParameters[0]?.Name === 'FState') {
                                    //     setResetCity(x => x + 1);
                                    //     // setResetNpi(x => x + 1);
                                    // }
                                    // if(messageEvent?.message?.changedParameters[0]?.Name === 'FCity') {
                                    //     setResetNpi(x => x + 1);
                                    // }
                                    // const params = await dashboard.getParameters()
                                    // setGlobalParameters(params);
                                    break;
                                }
                                case 'SELECTED_SHEET_CHANGED': {
                                    // console.log("Selected sheet changed. Selected sheet:", messageEvent.message.selectedSheet);
                                    setActiveSheet(messageEvent?.message?.selectedSheet?.SheetId)
                                    break;
                                }
                                // case 'SIZE_CHANGED': {
                                //     console.log("Size changed. New dimensions:", messageEvent.message);
                                //     break;
                                // }
                                // case 'MODAL_OPENED': {
                                //     window.scrollTo({
                                //         top: 0 // iframe top position
                                //     });
                                //     break;
                                // }

                                default:
                            }
                        },

          };

          if (dashboardType?.toLowerCase() === 'topic') {
            setDashboard(await embedGenerativeQnA(frameOptions, contentOptions))
          } else {
            setDashboard(await embedDashboard(frameOptions, contentOptions))
          }

          // setLoading(false);

        } else {

        } 
      } catch (err) {
        console.log('err: ', err)
      }

    
    } catch(error) {
      
      if(API.isCancel(error)) {
        // "my message for cancellation"
        console.log(error.message);
        // handle user cancellation logic
      }
        console.log(error)
        // setLoading(false);
        // setFailureMessage('There was an issue loading your dashboard. Please contact your administrator.');
    }
  }

  
  useEffect(() => {
      
    

    // if (dashboardId && embedContext && dashboardSubtype !== 'pivot') {
    
    if (dashboardId && embedContext && initialParams) {
        setDashboard();
        // setLoading(true);
        getDashboardUrl(initialParams);
    } else if (dashboardId && embedContext) {
        setDashboard();
        // setLoading(true);
        getDashboardUrl();
    }

    // return () => API.cancel(response, "my message for cancellation");
    // eslint-disable-next-line 
  },[dashboardId, embedContext, apiKey, dashboardType])

  
    useEffect(() => {
        dashboard && !loading && dashboard.setParameters(initialParams)
    }, [dashboard, loading, JSON.stringify(initialParams)])


    const setSheet = (sheetId) => {
        dashboard && dashboard?.setSelectedSheetId(sheetId)
    }


    useEffect(() => {

        const getStuff = async () =>{
            // const params = 
            // setGlobalParameters(await dashboard.getParameters());
            // const sheets = 
            if (!!dashboard?.getSheets) {
              const shts = await dashboard?.getSheets()
              // console.log('shts', )
                setSheets(shts?.filter((y) => y.Name ==='Breakdown' || y.Name ==='Overview' ||  y.Name ==='Leaderboard' || y.Name ==='Stat Lab' || y.Name ==='Prospect Matchup' ));
                // console.log('parameters', await dashboard.getParameters());
                // console.log('sheets', await dashboard.getSheets());
                setActiveSheet(await dashboard?.getSelectedSheetId());
            }
        }


        if(dashboard && !loading) {
            getStuff()
        }
    }, [dashboard, loading, numberOfParameterChanges])




    
  return <QuickSightTabs sheets={sheets} activeSheet={activeSheet} setActiveSheet={setSheet} dashboard={dashboard} loading={loading} dropdowns={dropdowns} initialParams={initialParams}>
    <div className={classes ? classes : 'flex flex-1 h-full py-4'} >
      <div 
        key={dashboardId}
        id={dashboardId}
        className="dashboardContainer quicksight-frame-wrap flex w-full relative " //position: "absolute", , maxHeight: "92vh"  
        style={{position: 'relative', height:`${height}px`}}
      >
        <Attribution />
        </div>
    </div>
  </QuickSightTabs>;
}

export default QuickSightDashboard2;